import React from "react";
import { LinearProgress as Progress } from "@material-ui/core";

const WaitCursor = props => <Progress {...props} />;

export default WaitCursor;
